module.exports = __webpack_public_path__ + "img/IMG_7195.e44fc847.webp";